import { StepData } from '../@types/step-data';

function transformApiKey(key: string): string {
  switch (key) {
    case 'panel_full_name':
    case 'panel_email':
    case 'panel_zip_code':
    case 'panel_phone_number':
      return 'panel_form_input';
    case 'panel_how_soon':
    case 'panel_who_needs_help':
      return 'panel_multiple_choice';
    default:
      return key;
  }
}

/**
 * Performs a transformation on all steps, to prepare its data for the Form component.
 */
export default function transformSteps(steps: StepData[]): StepData[] {
  return steps.map((step) => ({
    ...step,
    _modelApiKey: transformApiKey(step._modelApiKey),
  }));
}
